<template>
    <div>
        <div class="login-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-lg-5 mx-auto">
                        <div class="login-wrap password-form">
                            <div class="login-header">
                                <h3>Mot de passe oublié</h3>
                                <p>Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.</p>
                            </div>
                            <!-- Formulaire de réinitialisation de mot de passe -->
                            <form @submit.prevent="sendResetLink">
                                <div class="form-group group-img">
                                    <div class="group-img">
                                        <i class="feather-mail"></i>
                                        <b-form-input type="email" v-model="email" placeholder="Adresse e-mail" />
                                    </div>
                                </div>
                                <b-button variant="primary w-100 login-btn" type="submit">Envoyer</b-button>
                            </form>
                            <!-- /Formulaire de réinitialisation de mot de passe -->
                            <router-link to="/" class="back-home"><i class="fas fa-regular fa-arrow-left me-1"></i> Retour à la page d'accueil</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { forgotPassword } from '@/services/authService';
import Swal from 'sweetalert2';

export default {
    data() {
        return {
            email: ''
        }
    },
    methods: {
        async sendResetLink() {
            try {
                const response = await forgotPassword(this.email);
                Swal.fire({
                    icon: 'success',
                    title: 'Succès',
                    text: 'Lien de réinitialisation de mot de passe envoyé à votre adresse e-mail.'
                });
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'Échec de l\'envoi du lien de réinitialisation de mot de passe.'
                });
            }
        }
    }
}
</script>
